import { useContext } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../../assets/images/neer_logo.svg";
import * as Icon from "react-bootstrap-icons";
import Context from "../../../context";

function SideNavLink({ linkTo, icon, text, className }) {
  const { contextState, setContextState } = useContext(Context);

  return (
    <NavLink
      to={linkTo}
      className={`sidebar-link-wrapper ${className}`}
      onClick={() => {
        setContextState({ ...contextState, isSidebarOpen: false });
      }}
      exact
      activeClassName="active">
      <div className="sidebar-link">
        <div className="sidebar-link-content">
          {icon} <span className="sidebar-link-text">{text}</span>
        </div>
      </div>
    </NavLink>
  );
}

export default function SideBar({ children }) {
  const { contextState, setContextState } = useContext(Context);

  return (
    <div className={`sidebar-container-${contextState.isSidebarOpen}`}>
      <div className={`sidebar-${contextState.isSidebarOpen}`}>
        <div className="sidebar-wrapper">
          <div className="sidebar-header">
            <img src={logo} className="logo-image" alt="" />
            <Icon.X
              className="sidebar-x"
              height={22}
              width={22}
              onClick={() => {
                setContextState({ ...contextState, isSidebarOpen: false });
              }}
            />
          </div>
          <ul className="sidebar-body">
            <SideNavLink
              className="all-accounts-link"
              linkTo="/"
              icon={<Icon.Building className="btn-icon" />}
              onClick={() => {
                setContextState({ ...contextState, isSidebarOpen: false });
                setContextState({...contextState, detailActivePage: 'overview'})
              }}
              text="All Accounts"
            />
            <SideNavLink
              linkTo={`/account/${contextState.currentAccountId}/detail`}
              icon={<Icon.Grid className="btn-icon" />}
              text="Account Overview"
            />
            <SideNavLink
              linkTo={`/account/${contextState.currentAccountId}/pay-my-bill`}
              icon={<Icon.CreditCard className="btn-icon" />}
              text="Pay My Bill"
            />
            <SideNavLink
              linkTo={`/account/${contextState.currentAccountId}/autopay`}
              icon={<Icon.ArrowClockwise className="btn-icon" />}
              text="AutoPay"
            />
            <SideNavLink
              linkTo={`/account/${contextState.currentAccountId}/bills-and-usage`}
              icon={<Icon.FileEarmarkRuled className="btn-icon" />}
              text="Bills &amp; Usage"
            />
            <SideNavLink
              linkTo={`/account/${contextState.currentAccountId}/payment-history`}
              icon={<Icon.ClockHistory className="btn-icon" />}
              text="Payment History"
            />
            <SideNavLink
              linkTo={`/account/${contextState.currentAccountId}/payment-methods`}
              icon={<Icon.Wallet className="btn-icon" />}
              text="Payment Methods"
            />
            <SideNavLink
              linkTo={`/account/${contextState.currentAccountId}/profile`}
              icon={<Icon.Person className="btn-icon" />}
              text="My Profile"
            />
            <div
              onClick={() => {
                localStorage.clear()
                window.location.reload(false);
              }}>
              <SideNavLink
                linkTo=""
                icon={<Icon.BoxArrowLeft className="btn-icon" />}
                text="Log Out"
              />
            </div>
          </ul>
          <hr />
          <div className="sidebar-data">
            <p>{contextState.currentAccount?.customerName}</p>
            <p>Customer #: {contextState.currentAccount?.customerNumber}</p>
            <p>{contextState.currentAccount?.customerAddress}</p>
          </div>
        </div>
        <div className="sidebar-children-wrapper">{children}</div>
      </div>
    </div>
  );
}
